<template>
  <div class="help-center-page">
    <div class="help-center-header">
      <span class="help-center-title">{{$t('helpCenter')}}</span>
      <a-input-search  class="help-center-search" v-model="searchValue" placeholder="请输入搜索关键词" @search="onSearch"/>
    </div>

    <a-tabs  v-model.trim="key"  class="help-center-tab" @change="callback">
      <a-tab-pane :key="''"  :tab="$t('all')" >
        <div class="help-center-content">
          <div v-for="item in helpList" :key="item.NOTICE_ID">
            <div class="help-center-content-box" @click="goRouter(`/help/helpDetails?NOTICE_ID=${item.NOTICE_ID}`)">
              <img v-if="item.FILE_PATH" class="help-center-img" :src="$Dolphin.path.filePath + item.FILE_PATH">
              <div class="help-center-content-part">
                <span class="help-center-label">{{ $dt(item, 'CODE_NAME') }}</span>
                <span class="help-center-subject">{{ $dt(item, 'NOTICE_NAME') }}</span>
                <div class="help-center-info">{{ $dt(item, 'REMARK') }}</div>
              </div>
            </div>
            <a-divider/>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane v-for="item in helpSortList" :key="item.CODE_ID" :tab="$dt(item, 'CODE_NAME')" >
        <div class="help-center-content">
          <div v-for="item in helpList" :key="item.NOTICE_ID">
            <div class="help-center-content-box" @click="goRouter('/help/helpDetails')">
              <img v-if="item.FILE_PATH" class="help-center-img" :src="$Dolphin.path.filePath + item.FILE_PATH">
              <div class="help-center-content-part">
                <span class="help-center-label">{{ $dt(item, 'CODE_NAME') }}</span>
                <span class="help-center-subject">{{ $dt(item, 'NOTICE_NAME') }}</span>
                <div class="help-center-info">{{ $dt(item, 'REMARK') }}</div>
              </div>
            </div>
            <a-divider/>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
    <a-pagination  class="page-number" v-model="current" show-quick-jumper :total="total" @change="paginationChange" />
  </div>
</template>

<script>
import helpCenter from "@/views/help/helpCenter";
export default {
  name: "helpCenter",
  components: { helpCenter, },
  data(){
    return {
      searchValue: '',
      helpSortList: [],
      sql:`SELECT N.*,F.FILE_PATH,F.GUID_CODE,F.FILE_TYPE,B.CODE_NAME,B.CODE_NAME_ENG,B.CODE_NAME_RUS FROM GM_NOTICE N LEFT JOIN GM_FILE F ON convert(varchar(50),N.NOTICE_ID) = F.TARGET_ID
            LEFT JOIN BM_BASE_CODE B ON B.CODE_ID = N.NOTICE_CATE
            WHERE N.DEVICE_TYPE LIKE '%20361001%'
            AND N.SYS_TYPE = 20011003
            AND F.TARGET_TYPE = 20071008
            AND F.TARGET_CATE = 20021021
            AND F.STATUS = 1`,
      pageNumber: 10,
      current: 1,
      key:'',
      total: 0,
      helpList: []
    }
  },
  methods: {
    callback(key) {
      this.current = 1;
      this.key = key
      this.getNoticeList()
    },
    onSearch(val){
      this.getNoticeList(val)
    },
    paginationChange(val){
      this.current = val;
      this.getNoticeList()
    },
    goRouter(path) {
      this.$router.push(path);
    },
    searchHelpSort() {
      const data = [this.$dotNetUtil.commonQueryJson('BM_BASE_CODE',{TYPE_ID: '10000016'})];
      this.$h5Api({
        type: '1001',
        data,
      }).then(({data}) => {
        this.helpSortList = data.DATA_LIST
      })
    },
    getNoticeList(val){
      let sendData = [ this.$dotNetUtil.commonPageJson(this.sql, {NOTICE_CATE: this.key,NOTICE_NAME_like: val, NOTICE_NAME_ENG_like: val, NOTICE_NAME_RUS_like: val}, this.current , this.pageNumber, 'NOTICE_ORDER ASC', 2) ];
      this.$h5Api({
        type: 1001,
        data: sendData,
        showMessage: false,
      }).then(({data, total}) => {
        this.helpList = data.DATA_LIST;
        this.helpList.map(item => item.FILE_PATH = item.FILE_PATH + item.GUID_CODE + item.FILE_TYPE)
        this.total = total
      })
    }

  },
  created() {
    this.searchHelpSort();
    this.getNoticeList()
  }
}
</script>

<style lang="scss">
.help-center-page{
  padding: 16px 24px;
  border-radius: 5px;
  background-color: #FFFFFF;
  .help-center-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .help-center-title{
      color: #333333;
      font-size: 18px;
      font-weight: 600;
    }
    .help-center-search{
      width: 360px;
    }
    .ant-input {
      height: 36px;
      border: 1px #F7F7F7 solid;
      border-radius: 24px;
      background-color: #FCFCFC;
      box-shadow: 1px 2px 6px  rgba(173, 173, 173, 0.2);
    }
    .ant-input-suffix{
      right: 18px;
    }
  }
  .help-center-tab{
    padding-top: 16px;
  }
  .help-center-content-box{
    display: flex;

    .help-center-img{
      margin-right: 16px;
      height: 90px;
      border: 0.2px #E6E6E6 solid;
      border-radius: 2px;
    }
    .help-center-content-part{
      .help-center-label{
        height: 24px;
        padding: 2px 6px;
        font-size: 12px;
        color: #1890FF;
        border: 1px #91D5FF solid;
        border-radius: 5px;
        background-color: #E6F7FF;
      }
      .help-center-subject{
        margin-left: 12px;
        font-size: 16px;
        font-weight: 550;
        cursor: pointer;
      }
      .help-center-subject:hover{
        color: #1F6CBA;
      }
      .help-center-info{
        padding-top: 14px;
        font-size: 14px;
        color: #737373;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

  }
  .page-number{
    display: flex;
    justify-content: flex-end;
  }
}
</style>